import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW6600Component } from './kymw6600.component';
import { GetIndicationListService } from './api-services/get-indication-list.service';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';

/**
 * 特別指示書画面 モジュール設定クラス
 *
 * @export KYMW6600Module
 * @class KYMW6600Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6600Component,
  ],
  providers: [
    GetIndicationListService,
    FileDownloadConfirmService,
    FileDownloadService,
  ],
})
export class KYMW6600Module {
}
